import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { AuthService } from '../services/auth.service';
import { combineLatest, filter, map, Observable, take } from 'rxjs';
import { Store } from '@ngrx/store';
import { selectAuthLoading, selectIsLoggedIn } from '../store/selectors/auth.selectors';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router,
    private store: Store
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    return combineLatest([
      this.store.select(selectIsLoggedIn),
      this.store.select(selectAuthLoading),
    ]).pipe(
      filter(([_, selectAuthLoading]) => selectAuthLoading === false),
      take(1),
      map(([isLoggedIn]) => {
        if (isLoggedIn) {
          return true;
        }

        this.authService.redirectUrl = state.url;
        return this.router.parseUrl('/login');
      })
    );
  }
}
